import { Controller } from "@hotwired/stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static targets = ["input", "list"];

  connect() {
    this.abortController = null;
    this.activeIndex = -1;
    this.debouncedSearch = debounce(this.performSearch.bind(this), 300);
  }

  performSearch() {
    const query = this.inputTarget.value.trim();

    if (query.length < 3) {
      this.listTarget.innerHTML = "";
      return;
    }

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    fetch(`/autocomplete/${encodeURIComponent(query)}`, {
      signal: this.abortController.signal,
      headers: { Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        this.activeIndex = -1;
        this.listTarget.innerHTML = data
          .map((item) => {
            const badge =
              item.type === "brand"
                ? '<span class="badge bg-warning ms-2">Brand</span>'
                : "";
            return `<li class="list-group-item list-group-item-action"
                      role="option"
                      data-value="${item.label}"
                      data-id="${item.id || ""}"
                      data-type="${item.type}">
                        ${item.label}${badge}
                    </li>`;
          })
          .join("");
      });
  }

  search() {
    this.debouncedSearch();
  }

  select(event) {
    const value = event.target.dataset.value;
    const type = event.target.dataset.type;
    const id = event.target.dataset.id;
    const vendorHash = event.target.dataset.vendorHash;
    const brandSlug = event.target.dataset.brandSlug;

    if (!value) return;

    if (type === "style" && id && vendorHash && brandSlug) {
      const encodedStyle = encodeURIComponent(value);
      window.location.href = `/products/${vendorHash}/${brandSlug}/${encodedStyle}`;
      return;
    }

    this.inputTarget.value = value;
    this.listTarget.innerHTML = "";

    const form = this.inputTarget.closest("form");
    let typeInput = form.querySelector("input[name='type']");

    if (!typeInput) {
      typeInput = document.createElement("input");
      typeInput.type = "hidden";
      typeInput.name = "type";
      form.appendChild(typeInput);
    }

    typeInput.value = type;

    form.submit();
  }

  updateActiveItem(items) {
    items.forEach((el, idx) => {
      el.classList.toggle("active", idx === this.activeIndex);
    });
  }

  clearList() {
    this.listTarget.innerHTML = "";
    this.activeIndex = -1;
  }

  navigate(event) {
    const items = this.listTarget.querySelectorAll("li");
    if (items.length === 0) return;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      this.activeIndex = (this.activeIndex + 1) % items.length;
      this.updateActiveItem(items);
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      this.activeIndex = (this.activeIndex - 1 + items.length) % items.length;
      this.updateActiveItem(items);
    }

    if (event.key === "Enter" && this.activeIndex >= 0) {
      event.preventDefault();
      items[this.activeIndex].click();
    }

    if (event.key === "Escape") {
      this.clearList();
    }
  }
}
